// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

/* eslint-disable react/prefer-stateless-function */

class ClaimNumberWithKeyCellRenderer extends Component {

    render() {

        return (
            <div className='claim-cell-renderer'>
                {
                    this.props.data.claimType.key === 'ZPNV' ?
                        <SmartFormLink
                            displayText={this.props.value}
                            formName='CLAIM'
                            objectId={this.props.value}
                            translate={false}
                        /> :
                            <a
                                className='claim-link'
                                href={`#${buildClaimRoutes(encodeURI(this.props.data.claimType.key), encodeURI(this.props.data.subClaimType.key), encodeURI(this.props.value))}`}
                                rel='noopener noreferrer'
                                target='_blank'
                            >
                                {formatClaimNumber(this.props.value)}
                            </a>
                }
            </div>
        );

    }

}

ClaimNumberWithKeyCellRenderer.displayName = 'ClaimNumberWithKeyCellRenderer';
ClaimNumberWithKeyCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default ClaimNumberWithKeyCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/claim-number-with-key-cell-renderer.js